

<template>
  <div class="mb-4">
    <h5 class="mb-2">
      {{ "query_done" | setText("Заявка была обработана") }}
    </h5>
    <cancel
      :currentRequest="currentRequest"
      :model_type="`subscription`"
      :model_id="id"
      @update="update"
    />
  </div>
</template>
<script>
import cancel from "@/components/Cancel.vue";
export default {
  components: { cancel },
  methods: {},
  data: () => ({}),
  props: ["id", "currentRequest"],
  methods: {
    update() {
      this.$emit("update", true);
    },
  },
};
</script>

 
 
